import React, { useState } from 'react';
import { HeartIcon } from 'lucide-react';
import { useDarkClasses } from '../../hooks/useDarkClasses';
interface SaveToFavoritesProps {
  itemId: string;
  initialSaved?: boolean;
  className?: string;
  size?: 'sm' | 'md';
}
const SaveToFavorites: React.FC<SaveToFavoritesProps> = ({
  itemId,
  initialSaved = false,
  className = '',
  size = 'md'
}) => {
  const dk = useDarkClasses();
  const [isSaved, setIsSaved] = useState(initialSaved);
  const handleSave = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsSaved(!isSaved);
  };
  const sizeClasses = size === 'sm' ? 'p-1.5' : 'p-2';
  const iconSize = size === 'sm' ? 'h-4 w-4' : 'h-5 w-5';
  return <button onClick={handleSave} className={`rounded-full transition-all duration-200 shadow-sm ${isSaved ? 'bg-purple-600 text-white hover:bg-purple-700' : dk.isDark ? 'bg-gray-800/90 text-gray-400 hover:bg-gray-700 hover:text-purple-400' : 'bg-white/90 text-gray-500 hover:bg-white hover:text-purple-600'} ${sizeClasses} ${className}`} aria-label={isSaved ? 'Remove from favorites' : 'Save to favorites'} title={isSaved ? 'Saved to favorites' : 'Save to favorites'} data-id="element-3877" data-mp="s6mxg7c2f8rl">
      <HeartIcon className={`${iconSize} ${isSaved ? 'fill-current' : ''}`} data-id="element-3878" data-mp="1t6871bhf3boh" />
    </button>;
};
export default SaveToFavorites;